import PropTypes from 'prop-types';
import React from 'react';
import {home} from 'src/shared/pagePaths';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import Exclamation from 'src/svgs/status/exclamation.svg';
import {header} from '../header.module.scss';
import {
  icon,
  text,
  warn,
} from './style.module.scss';

export const ErrorView = ({
  onCancel,
  onTryAgain,
}) => {
  return (
    <>
      <header className={header}>
        <Exclamation className={`${icon} ${warn}`} />
        <h1 className={text}>We&apos;re having some trouble scheduling your callback</h1>
        <p>Try again or visit our support site for more help.</p>
      </header>
      <div className={buttonGroup}>
        <button className={`${button} ${primary}`} onClick={onTryAgain}>Try Again</button>
        <a className={button} onClick={onCancel} href={home()}>Go to Support</a>
      </div>
    </>
  );
};

ErrorView.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onTryAgain: PropTypes.func.isRequired,
};
